<template>
  <div>

    <div class="login-head fc-bet container">
      <div class="fc">
        <a href="" class="logo fc" v-if="false">
          <img src="@/assets/logo.jpg" alt="" srcset="">
        </a>
        <div class="login-title">
          欢迎注册
        </div>
      </div>
      <div class="login-right-logo reg-right-logo fc">
        <span>已有账号?</span>
        <router-link to="login">
          请登录
        </router-link>
      </div>
    </div>
    <div class="register-container">
      <div class="steps">
        <div class="step-item " :class="{'active': stepActive === 1}">
          <div class="step-item-container">
            <div class="steps-item-tail"></div>
            <div class="step-item-icon">
              <span class="step-icon">1</span>
            </div>
            <div class="step-item-content ng-binding">
              企业用户
            </div>
          </div>
        </div>
        <div class="step-item" :class="{'active': stepActive === 2}">
          <div class="step-item-container">
            <div class="steps-item-tail"></div>
            <div class="step-item-icon">
              <span class="step-icon">2</span>
            </div>
            <div class="step-item-content ng-binding">
              企业信息
            </div>
          </div>
        </div>
        <div class="step-item" :class="{'active': stepActive === 3}">
          <div class="step-item-container">
            <div class="step-item-icon">
              <span class="step-icon">3</span>
            </div>
            <div class="step-item-content">
              注册完成
            </div>
          </div>
        </div>
      </div>
      <div class="box" v-if="stepActive === 1">
        <div class="type-content">
          <div class="type-item active">
            <img class="icon" src="../assets/enterprise.png">
            <span>我是客户</span>
            <img class="dot" src="../assets/jiaobiao.png" alt="">
            <p>惊喜折扣</p>
          </div>
          <!-- <div class="type-item">
                        <img class="icon" src="/images/register/user-active.png">
                        <span>我是个人</span>
                    </div> -->
        </div>
        <div class="btns">
          <button type="button" class="btn" @click="register(2);">立即注册</button>
        </div>
      </div>
      <div class="personal-register" v-if="stepActive === 2">
<!--        <form action="" class="form">-->
          <el-form ref="form" :model="form" :rules="rules" size="small" :inline="true" label-width="140px" class="form">
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>推荐码
            </div>
            <input type="text" class="input " placeholder="请输入推荐码" v-model="form.pid" @blur="fillPName()">
            <input type="text" class="input " placeholder="根据推荐码显示名称" v-model="form.pName" :readonly="true">
            <div class="tip err" v-if="!form.pid">
              请致电您的上级经销商索取推荐码
            </div>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>手机号
            </div>
            <input type="tel" class="input" placeholder="请输入手机号" v-model="form.contactsMobile">
            <!-- <div class="tip err" v-if="!phone">
              手机号码不能为空
            </div> -->
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>联系人
            </div>
            <input type="text" class="input" placeholder="请输入联系人姓名" v-model="form.contacts">
            <div class="tip err">
            </div>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>验证码
            </div>
            <input type="text" class="input sms" placeholder="请输入验证码" v-model="form.code">
            <div class="btn-send-code" v-if="isSend==false">
              <ge-code :config="config"></ge-code>
            </div>
            <div class="btn-send-code" v-else>
              获取短信验证码
            </div>
            <div class="tip err">
            </div>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>登录密码
            </div>
            <input type="password" v-model="form.password" class="input" placeholder="请设置密码(6-18个字符)"
                   maxlength="11" v-if="pwd_hide">
            <input type="text" v-model="form.password" class="input" placeholder="请设置密码(6-18个字符)" maxlength="11"
                   v-else>
            <img src="@/assets/pwd_hide.svg" class="passwordImg" alt="" v-if="pwd_hide"
                 @click="pwd_hide=!pwd_hide">
            <img src="@/assets/pwd_show.svg" class="passwordImg" alt="" v-else
                 @click="pwd_hide=!pwd_hide">
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>确认密码
            </div>
            <input type="password" v-model="form.password2" class="input" placeholder="请重复输入密码(6-18个字符)"
                   maxlength="11"
                   v-if="pwd_hide2">
            <input type="text" v-model="form.password2" class="input" placeholder="请重复输入密码(6-18个字符)"
                   maxlength="11"
                   v-else>
            <img src="@/assets/pwd_hide.svg" class="passwordImg" alt="" v-if="pwd_hide2"
                 @click="pwd_hide2=!pwd_hide2">
            <img src="@/assets/pwd_show.svg" class="passwordImg" alt="" v-else
                 @click="pwd_hide2=!pwd_hide2">
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>公司名称
            </div>
            <input type="text" class="input" placeholder="请输入公司名称" v-model="form.name">
            <div class="tip err">
            </div>
          </div>
          <!--					<div class="form-group" v-if="false">-->
          <!--						<div class="tips">-->
          <!--							<span class="require">*</span>用户类型-->
          <!--						</div>-->
          <!--						<select name="" id="" class="phone-merchant">-->
          <!--							<option value="">&#45;&#45;请选择&#45;&#45;</option>-->
          <!--						</select>-->
          <!--						<div class="tip err" >-->
          <!--						</div>-->
          <!--					</div>-->
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>营业执照
            </div>
            <div class="upload">
              <el-upload
                  action="https://zxapi.tengen.com.cn/api/pc-shop/upload"
                  class="upload-demo"
                  :on-success="handleAvatarSuccess"
                  :show-file-list="false"
                  drag>
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-if="!imageUrl" class="el-icon-upload"></i>
                <div v-if="!imageUrl" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div v-if="!imageUrl" class="el-upload__tip" slot="tip">支持png／jpg／jpeg图片格式（大小5M以内）</div>
              </el-upload>
            </div>
            <div class="tip err">
            </div>
          </div>
          <!--					<div class="form-group" v-if="false">-->
          <!--						<div class="tips">-->
          <!--							<span class="require">*</span>公司地址-->
          <!--						</div>-->
          <!--						<div class="city-selects">-->
          <!--							<div class=" flex1 fc-bet" style="margin-bottom: 15px;">-->
          <!--								<select name="" id="" class="city-select">-->
          <!--									<option value="">&#45;&#45;省份&#45;&#45;</option>-->
          <!--								</select>-->
          <!--								<select name="" id="" class="city-select">-->
          <!--									<option value="">&#45;&#45;城市&#45;&#45;</option>-->
          <!--								</select>-->
          <!--								<select name="" id="" class="city-select">-->
          <!--									<option value="">&#45;&#45;县区&#45;&#45;</option>-->
          <!--								</select>-->
          <!--							</div>-->
          <!--							<input type="text" class="input" placeholder="请输入联系地址" style="width: 428px;">-->
          <!--						</div>-->
          <!--						<div class="tip err" >-->
          <!--						</div>-->
          <!--					</div>-->
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>社会统一信用代码
            </div>
            <!--						<input type="text" class="input " placeholder="">-->
            <input type="text" class="input " placeholder="请输入社会统一信用代码" v-model="form.unifiedSocialCreditCode">
          </div>
          <div class="form-group">
            <label for="registerBtn" class="checkboxStyle-small fc"
                   style="text-align: left !important;width: 360px!important;font-size: 12px;">
              <input id="registerBtn" type="checkbox" v-model="isReady" @click="isReadyFun">
              <span></span>&nbsp;
              点击注册，表示您同意
              <a href="javascript:void(0)" class="cregisColor" @click="dialogVisible = true">《天正用户协议》</a>
            </label>
          </div>
          <div class="form-group">
            <button type="button" class="btn default" @click="onPrev()">上一步</button>
            <button type="button" class="btn" id="registerBtn" @click="register(3);">同意协议注册</button>
          </div>
          </el-form>
      </div>
      <div class="personal-register3" v-if="stepActive === 3">
        您的账号正在审核中，审核通过后会以短信的形式通知您，请耐心等待！
      </div>
    </div>

    <el-dialog
        title="天正智选平台用户协议"
        :visible.sync="dialogVisible"
        width="1000px">
      <div style="height: 60vh;overflow-y: auto; padding-right: 20px;">

        <p ><strong>一、平台</strong><strong>服务</strong><strong><br />
        </strong><br />
          1、智选平台致力于打造便捷化商务订单，通过互联网及相关软硬件设施为注册会员提供质优价廉的电气产品！智选平台秉承客户至上的经营理念，为用户提供优质服务，让用户获取完美网购体验。<br />
          <br />
          2、智选平台的网站所有权、运作权及所涉及的一切知识产权归浙江天正电气股份有限公司（下称“天正公司”）所有。用户在享受智选平台提供服务同时，应受本协议条款的约束。用户通过注册流程并完成注册，表示用户完全理解并接受本协议的各项条款，在享有条款授予权利的同时， 受到相关的约束和限制。当用户在使用智选平台各单项服务时，用户享受服务的行为被视为对单项服务条款以及该单项服务中发出的各类公告的认可。 </p>
        <p >&nbsp;</p>
        <p ><strong>二、说明与保证</strong><strong><br />
        </strong><br />
          1、 智选平台保证所有商品均为授权经销商提供。<br />
          <br />
          2、 智选平台尽最大努力确保网站图片与实物的一致性，但由于拍摄角度、光线强度、不同显示器的色差等客观因素仍有可能导致出现误差，此种情况不属于质量问题范畴。图片仅供参考，一切以实物为准。<br />
          <br />
          3、 有关商品质量的检测，依国家、行业标准执行。<br />
          <br />
          <br />
          <br />
          三、<strong>注册与使用</strong><strong><br />
          </strong><br />
          1、用户注册时需提供营业执照及使用人员的手机号码，用户应当确保其提供的信息的真实性、正确性、完整性，该类信息更新时，用户应当自行及时在智选平台上进行修改操作。因用户提供虚假信息或者因信息资料滞后造成的损失由用户自行承担。 </p>
        <p >2、用户注册成为会员，将拥有一个专属于个人的用户名和密码，请妥善保管。因个人保管不善引起的责任，由个人承担。除非经司法裁定或者征得天正公司同意，用户账户不得以任何方式进行转让、赠予或者继承。<br />
          <br />
          3、用户承诺对智选平台及相关服务的使用符合部门规章、国家法律的规定，并对自己发布的内容以及对通过账户实施的行为独立承担责任。<br />
          <br />
          4、用户承诺在平台上发布信息或者利用智选平台的服务时必须符合中国有关法规，不在智选平台的网页上或者利用智选平台的服务制作、复制、发布、传播以下信息：<br />
          <br />
          （1）违反国家各项法律法规的以及法律法规禁止的、泄露国家机密、破坏国家统一的；<br />
          （2）危害国家安全、破坏名族团结、损害国家利益的；<br />
          （3）破坏国家宗教政策、宣扬邪教和封建迷信的；<br />
          （4）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
          （5）侮辱或者诽谤他人，侵害他人合法利益的。<br />
          <br />
          5、用户承诺不利用智选平台提供的服务从事制作、传播计算机病毒等破坏性程序；不从事危害计算机信息网络安全的行为；不以任何方式干扰智选平台的正常运行。<br />
          <br />
          6、用户不得在平台上进行虚假交易或骗取积分，若发生相关事项，其法律后果及法律责任由用户承担，给天正公司及其经销商造成损失的，用户还应赔偿损失。<br />
          <br />
          <br />
          <strong>四、</strong><strong>隐私</strong><strong>保护</strong><strong> </strong><br />
          <br />
          1、智选平台为用户带来便捷服务的同时，充分尊重和保护个人信息和隐私。智选平台不会公开、修改或透露用户的注册资料及保存在智选平台各项服务中的非公开内容。<br />
          <br />
          2、如用户同意智选平台或者要求智选平台可以透露某些信息的，或者在法律法规要求下需要智选平台提供个人信息的，或者智选平台认为确其它必要的，智选平台会在诚信的基础上、确有必要的前提下公开。<br />
          <br />
          3、智选平台的信息服务是根据用户主动申请而提供的，除了少量的服务动态信息，我们不会任意推送无关的信息到用户的手机短信。<br />
          <br />
          <br />
          <strong>五、责任限制</strong><strong><br />
          </strong><br />
          用户明确同意会员服务的使用由用户个人承担风险，智选平台不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性不作任何担保。智选平台拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。<br />
          <br />
          <br />
          <strong>六、</strong><strong>修订</strong><strong>与通知</strong><strong><br />
          </strong><br />
          1、智选平台会在必要时修改服务条款，服务条款一旦发生变动，将会在重要页面上提示修改内容或通过其他形式告知用户。<br />
          <br />
          2、所有重要信息的通告，包括条款的修改、服务变更等重要事情，网站可以以电子邮件、站内消息、网站页面显要位置公告的形式告知用户。<br />
          <br />
          <strong>七、</strong><strong>结束服务</strong><strong><br />
          </strong><br />
          用户或者智选平台可随时根据实际情况中止网站服务。结束用户服务后，用户使用智选平台会员服务的权利马上中止，智选平台不再对用户承担任何义务。<br />
          <br />
          <br />
          <strong>八、其他</strong><strong><br />
          </strong>1、本协议各条款独立，部分条款无效不影响其他条款及本协议的效力。如双方就本协议内容或因履行本协议发生任何争议，双方应尽力友好协商解决；协商不成的，任何一方均可本站所在地的人民法院提起诉讼。 </p>
        <p >2、本协议及智选平台使用规则最终解释权归天正所有。 </p>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
    </el-dialog>
    <i-footer></i-footer>

  </div>
</template>

<script>

import geCode from 'vue-gecode'
import {getToken} from "@/axios/cookies";
import {getDistributorInfo, getVerify, registerSubmit} from "@/api/login";
import IFooter from "@/components/i-footer";

export default {
  components: {
    geCode
  },
  data() {
    return {
      headers: {
        Authorization: getToken()
      },
      dialogVisible:false,
      isSend: false,
      form: {
        pid: null,
        pName:null,
        contacts: null,
        contactsMobile: null,
        code: null,
        password: null,
        password2: null,
        name: null,
        operationLicense: null,
        unifiedSocialCreditCode: null,

      },
      rules: {
        name: [
          {required: true, message: '经销商名称不能为空', trigger: 'blur'}
        ],
      },
      isReady: false,
      stepActive: 1,
      imageUrl: null,
      phone: null,
      recommendationCode: null,
      password: "",
      repassword: "",
      pwd_hide: true,
      pwd_hide2: true,
      config: {
        //开始时候的文本
        startText: '获取短信验证码',
        //获取验证码结束后文本
        endText: '再次获取',
        //验证码倒计时总时间(秒)
        totalTime: 60,
        //验证码每次隔多久变一次(秒)
        tickTime: 1,
        //倒计时执行期添加的class 默认 isRun
        activeClass: 'isRun',
        //自定义倒计时期间文本的显示内容
        computeText(num) {
          //num 倒计时时间
          return '重新获取 ' + num + 's';
        },
        //是否可以发送
        canTodo: () => {
          //返回值判定是否可以发送
          // let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
          // console.log('判断是否可以发送验证码', result);
          // if (!result) {
          //   alert('手机号格式不正确');
          // }
          if (this.form.contactsMobile){
            return true
          }else{
            return false;
          }
        },
        //canTode验证成功后执行 发送短信验证码
        todo: () => {
          //这里写验证码的获取程序
          console.log('发送验证码')
          getVerify({
            phone:this.form.contactsMobile,
            type:'register'
          }).then(res=>{
            console.log('发送短信',res)
          }).catch(e=>{
            console.log('发送短信报错信息',e)
            this.$message.error(e.msg);
          })
          //同时手机号不可改变了
          this.readonly = true
        },
        //发送完成后的回调
        endCallback(type, config) {
          //type 回调产生原因  0: 时间结束   其他值由this.$refs.geCode.stop(1)调入自定义
          //config config配置
          console.log('发送完成后的回调', type, config);
          //同时手机号可改变了
          this.readonly = false
        },
        //每次点击都会被调用
        click(isRun) {
          //isRun 是否在运行中
          console.log(`当前验证码状态是:${isRun ? '发送中' : '可发送'}状态`)
        },
        //是否可用   默认ture
        canUse: true,
        //不可用时的类名  默认no-can
        noCanClass: 'no-can',
      },
    }
  },
  mounted() {


  },
  computed: {
    // showSendSms() {
    //   // let result = /^1[3456789]\d{9}$/.test(this.form.contactsMobile);
    //   // console.log("验证码", result)
    //   return true
    //   if (this.form.contactsMobile&& this.form.contactsMobile.length==11){
    //     return true
    //   }else{
    //     return false
    //   }
    // },
  },
  watch: {
    "imageUrl":function (val) {
      console.log('上传后检测参数',this.imageUrl)
      this.form.operationLicense=this.imageUrl
    }
  },
  methods: {
    isReadyFun() {
      console.log(this.isReady)
    },
    handleAvatarSuccess(res, file) {
      // this.operationLicenseUrl = res.link
      this.imageUrl = res.link
    },
    sendCode() {
      this.$refs.timerbtn.setDisabled(true); //设置按钮不可用

    },
    
    getDistributorInfoByPid(pid){
	    getDistributorInfo({distributorId:pid}).then(res => {
	      console.log('注册页面获取到的上级信息',res.data.name)
        this.form.pName = res.data.name;
	    })
	  },
    fillPName() { // 提示上级经销商名称
		let pid = this.form.pid
		console.log("pid.....", pid);
		if (pid && pid >0){
	      this.getDistributorInfoByPid(pid);		  
	    }else{
        this.form.pName = null;
      }		
	  },
    onPrev() {
      this.stepActive = 1
    },
    register(i) {
      console.log(i)
      if (i<3){
        this.stepActive = i
        return;
      }
      if (!this.form.pid){
        this.$message.error('推荐码不能为空');
        return
      }
      if (!this.form.contacts){
        this.$message.error('联系人不能为空');
        return
      }
      if (!this.form.contactsMobile){
        this.$message.error('手机号不能为空');
        return
      }
      if (!this.form.password){
        this.$message.error('密码不能为空');
        return
      }
      if (!this.form.password2){
        this.$message.error('重复密码不能为空');
        return
      }
      if (this.form.password != this.form.password2){
        this.$message.error('俩次密码不一致！');
        return
      }
      if (!this.form.name){
        this.$message.error('公司名称不能为空');
        return
      }
      if (!this.form.operationLicense){
        this.$message.error('营业执照不能为空');
        return
      }
      if (!this.form.unifiedSocialCreditCode){
        this.$message.error('社会统一信用代码不能为空');
        return
      }
      if (!this.form.code){
        this.$message.error('验证码不能为空');
        return
      }
      if (!this.isReady){
        this.$message.error('请同意《天正用户协议》');
        return
      }
      registerSubmit(this.form).then(res=>{
        console.log('注册返回值',res)
        if (res.status == 200){
          this.stepActive = i
        }else{
          this.$message.error(res.msg);
        }
      })

    }
  },


}
</script>

<style lang="less" scoped>
@import '@/assets/reg.less';

.city-selects {
  width: 450px;
}

.city-select {
  width: 160px;

}

.city-select + .city-select {
  margin-left: 15px;
}

.btn-send-code {
  height: 50px;
  margin-left: 15px;
  line-height: 50px;

  span {
    height: 50px;
    line-height: 50px;
  }
}

.el-upload__tip {
  padding: 10px 0;
}


/*复选框换成图片*/
.checkboxStyle-small {
  display: inline-block;
  cursor: pointer;
}

.checkboxStyle-small input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  display: none;
}

.checkboxStyle-small input[type="checkbox"]:disabled + span {
  opacity: .4;
  position: relative;
  top: -1px;
}

.checkboxStyle-small input[type="checkbox"] + span {
  width: 13px;
  height: 13px;
  display: inline-block;
  position: relative;
  top: -1px;
  background: url('../assets/company-default.png') no-repeat -725px -10px;
  vertical-align: text-bottom;
}

.checkboxStyle-small input[type="checkbox"]:checked + span {
  background-position: -725px -24px;
}

.personal-register .btn {
  height: 50px;
  line-height: 50px;
  width: 40%;
  border-radius: 20px;
  font-size: 22px;
}

.personal-register .btn.default {
  background: #fff;
  color: @l;
  border: 1px solid @l;
  width: 25%;
}

.personal-register .btn + .btn {
  margin-left: 20px;
}

.personal-register3 {
  text-align: center;
  padding: 25px 0 20vh;
  font-size: 22px;

  a {
    color: @L;
    text-decoration: underline;
  }
}
</style>
<style lang="less">
.personal-register {


  .el-upload {
    display: block;
  }

  .el-upload-dragger {
    width: 450px;
    border-radius: 0;
  }

}

</style>
